<template>
  <div>
    <div class="google-map" :id="mapName"></div>
  </div>
</template>

<script>

export default {
  name: 'GoogleMap',
  props: {
    name: {
      require: true,
    },
    enableMarkers: {
      type: Boolean,
      default: true,
      require: false,
    },
    enableRadius: {
      type: Boolean,
      default: false,
      require: false,
    },
    enableInfoWindow: {
      type: Boolean,
      default: false,
      require: false,
    },
    enableMapControls: {
      type: Boolean,
      require: false,
      default: false,
    },
    enableMapBounds: { // Adjusts the map position & zoom automatically according to marker co-orodinates
      type: Boolean,
      require: false,
      default: true,
    },
    zoom: {
      type: Number,
      require: false,
      default: 17,
    },
    mapCenterLat: {
      type: String,
      require: false,
    },
    mapCenterLong: {
      type: String,
      require: false,
    },
    markersInfo: {
      type: Array,
      require: false,
    },
    /*
      --- Example Array for markers
      [
        {
          latitude: -33.896030,
          longitude: 151.200040,
          icon: 'https://cdn.openagent.com.au/img/blog/map-marker-greed-solid.png', // optional uses this.icon as default
          infoWindowContent: `<p>test</p>` // Optional - Expects a html string
        }
      ]

    */
    markerIcon: {
      type: String,
      require: false,
      default: 'https://cdn.openagent.com.au/img/blog/map-marker-greed-solid.png',
    },
  },
  data() {
    return {
      mapName: `${this.name}-map`,
      map: null,
      bounds: null,
      markers: [],
    };
  },
  watch: {
    markersInfo: function(data) {
      this.reloadMap();
    },
  },
  methods: {
    reloadMap() {
      this.bounds = this.$apiServices.google.maps.LatLngBounds();
      const element = document.getElementById(this.mapName);
      const mapCentre = this.markersInfo[0];
      const infowindow = this.enableInfoWindow ? this.$apiServices.google.maps.InfoWindow() : null;

      const options = {
        zoom: this.zoom,
        center: this.mapCenterLat && this.mapCenterLong ? this.$apiServices.google.maps.LatLng(this.mapCenterLat, this.mapCenterLong) : this.$apiServices.google.maps.LatLng(mapCentre.latitude, mapCentre.longitude),
        disableDefaultUI: !this.enableMapControls,
      };

      this.map = this.$apiServices.google.maps.Map(element, options);

      // Do we want to show the markers? (default == true)
      if (this.enableMarkers) {
        this.markersInfo.forEach((coord) => {
          const position = this.$apiServices.google.maps.LatLng(coord.latitude, coord.longitude);
          const marker = this.$apiServices.google.maps.Marker({
            position,
            map: this.map,
            icon: coord.icon ? coord.icon : this.markerIcon,
          });

          this.markers.push(marker);

          if (this.markersInfo.length > 1 && this.enableMapBounds) {
            this.map.fitBounds(this.bounds.extend(position));
          }

          if (this.enableInfoWindow) {
            marker.addListener('click', () => {
              infowindow.setContent(coord.infoWindowContent);
              infowindow.open(this.map, marker);
            });

            this.map.addListener('click', () => {
              infowindow.close();
            });
          }
        });
      }

      // Do we want to show the radius circle? (default == false)
      if (this.enableRadius) {
        const radiusCircle = this.$apiServices.google.maps.Circle({
          strokeColor: '#00AB55',
          strokeOpacity: 0.8,
          strokeWeight: 1,
          fillColor: '#00AB55',
          fillOpacity: 0.3,
          map: this.map,
          center: this.$apiServices.google.maps.LatLng(mapCentre.latitude, mapCentre.longitude),
          radius: Math.sqrt(1) * 100, // 100m2
        });
      }
    },
  },
  mounted() {
    this.reloadMap();
  },
};
</script>

<style lang="scss">

.google-map {
  width: 100%;
  height: 100%;
  min-height: 250px;
  margin: 0 auto;

  .gm-style {
    .gm-style-iw-t::after {
        height: 0px;
      }

    .gm-style-iw {
      padding: 5px !important;
      border-radius: 3px;
      box-shadow: 0 2px 12px 0 rgba(111,106,106,0.5);

      .gm-style-iw-d {
        padding-left: 17px;
        padding-top: 10px;
      }


      button {
        display: none !important;
      }

    }

  }

}

// .gm-style .gm-style-iw-t::after {
//       height: 0px;
//     }

</style>
